/* eslint-disable no-unused-vars */
import {
    Button, Space, Tag, Tooltip,
} from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MdOutlineWeb, MdOutlineTimeline } from 'react-icons/md';

interface Props {
    timelineType: boolean;
    handleChangeTimelineType: (type: boolean) => void;
}

const TimelineType: FC<Props> = ({ timelineType, handleChangeTimelineType }) => {
    const { t } = useTranslation('bookings');

    return (
        <Space size={8} align="center">
            <Tooltip title={t('DETAIL.CHANGE_TIMELINE_TYPE')}>
                <Button
                    type="primary"
                    icon={(
                        timelineType ? (
                            <MdOutlineWeb size={16} style={{ verticalAlign: 'middle' }} />
                        ) : (
                            <MdOutlineTimeline size={16} style={{ verticalAlign: 'middle' }} />
                        )
                    )}
                    onClick={() => handleChangeTimelineType(!timelineType)}
                    size="small"
                />
            </Tooltip>
            <Tag color="gold">
                {t('DETAIL.CHANGE_VIEW')}
            </Tag>
        </Space>
    );
};

export { TimelineType };
